import React, { memo } from "react";
import { ProductModelPreview } from "./ProductSubCategoryPanels";

/* ---------- Static dropdown config (Louver Aluminum Assembly) ---------- */

// attributeName -> selected value -> model list
export const MODEL_OPTIONS = {
    "Fresh Air Louver": { Yes: ["FAL245"] },
    "Sand Trap Louver": { Yes: ["KSTL"] },
    Damper: {
        "Volume Control Damper": ["JB11", "JB12", "JB11-V4"],
        "Motorized Volume Control Damper": [
            "JB11-M",
            "JB12-M",
            "JB11-V4-M",
            "JB12-V4-M",
        ],
    },
};

// Used until the API data (assembly product FAI) is loaded
export const FALLBACK_ATTRS = [
    { name: "Fresh Air Louver", values: ["Yes", "No"] },
    { name: "Sand Trap Louver", values: ["Yes", "No"] },
    {
        name: "Damper",
        values: ["Volume Control Damper", "Motorized Volume Control Damper", "No"],
    },
    { name: "Accessories", values: ["Yes", "No"] },
];

export const INITIAL_ASSEMBLY = { values: {}, models: {} };

//  default selected
export const DEFAULT_ASSEMBLY = {
    values: {
        "Fresh Air Louver": "Yes",
        "Sand Trap Louver": "Yes",
        Damper: "Volume Control Damper",
        Accessories: "Yes",
    },
    models: {
        "Fresh Air Louver": "FAL245",
        "Sand Trap Louver": "KSTL",
        Damper: "JB11",
    },
};

const toId = (name) => `asm-${name.replace(/\s+/g, "-").toLowerCase()}`;

const AsmSelect = ({ id, value, onChange, placeholder, options }) => (
    <select
        id={id}
        className="asm-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
    >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
            <option key={opt} value={opt}>
                {opt}
            </option>
        ))}
    </select>
);

/* ---------- Dropdown rows ---------- */

export const AssemblyDropdownFilters = memo(function AssemblyDropdownFilters({
    attributes = [],
    value = INITIAL_ASSEMBLY,
    onChange,
}) {
    const setValue = (name, v) =>
        onChange({
            values: { ...value.values, [name]: v },
            models: { ...value.models, [name]: "" },
        });

    const setModel = (name, v) =>
        onChange({ ...value, models: { ...value.models, [name]: v } });

    return (
        <div className="asm-list">
            {attributes.map((attr) => {
                const selected = value.values[attr.name] ?? "";
                const models = MODEL_OPTIONS[attr.name]?.[selected] ?? [];
                const id = toId(attr.name);

                return (
                    <div className="asm-row" key={attr.name}>
                        <label className="asm-label" htmlFor={id}>
                            {attr.name}
                        </label>
                        <AsmSelect
                            id={id}
                            value={selected}
                            placeholder={
                                "Select"
                            }
                            options={attr.values}
                            onChange={(v) => setValue(attr.name, v)}
                        />
                        {models.length > 0 ? (
                            <AsmSelect
                                id={`${id}-model`}
                                value={value.models[attr.name] ?? ""}
                                placeholder="Select model"
                                options={models}
                                onChange={(v) => setModel(attr.name, v)}
                            />
                        ) : (
                            <span aria-hidden="true" />
                        )}
                    </div>
                );
            })}
        </div>
    );
});

/* ---------- Product cards (original component) ---------- */

export const ProductModelPreviewList = memo(function ProductModelPreviewList({
    products = [],
    onConfigureProduct,
}) {
    return (
        <div className="psc-multi-list">
            {products.map((product) => (
                <div className="psc-multi-item" key={product.id}>
                    <ProductModelPreview
                        matchedProduct={product}
                        breadcrumbParts={[]}
                        hasSelection
                        matchCount={products.length}
                        candidateProducts={[]}
                        onConfigure={() => onConfigureProduct(product)}
                        onCandidateClick={() => { }}
                    />
                </div>
            ))}
        </div>
    );
});